// CDM/OCF/PP are Irish reimbursement programmes (PCRS), so the patient's country must be
// Ireland. The test itself is shared with the address form, which stops offering Irish
// counties and an Eircode for a non-Irish patient (KIN-1650) — one definition of "is this
// Irish", two callers with different consequences.
import { isIrishCountry } from "utils/country";

export { isIrishCountry };

// True when the patient's country is explicitly set to something other than
// Ireland. Mirrors the deceased trigger: it blocks all CDM/OCF/PP review actions
// and shows a blocking notice.
export const isNonIrishForCdm = (country) => !isIrishCountry(country);
